import builderPathInit from '../../../util/builder-path-init';
import { builder } from '@builder.io/react/lite';
import getConfig from 'next/config';

const pathPrefix = '/blog/article';
const model = 'blog-article';

const {
  publicRuntimeConfig: { GF_DOTCOM_ENV },
} = getConfig();

const builderComponentQuery =
  GF_DOTCOM_ENV === 'production'
    ? {
        query: {
          data: {
            environment: GF_DOTCOM_ENV ?? 'production',
          },
        },
      }
    : {};

const { BuilderPage } = builderPathInit({
  model: model,
});

export default BuilderPage;

export async function getServerSideProps(context) {
  const {
    params: { id },
  } = context;
  const urlPath = id ? `${pathPrefix}/${id}` : pathPrefix;
  const content = await builder
    .get(model, {
      userAttributes: {
        urlPath,
        ...builderComponentQuery,
      },
      options: { enrich: true, includeRefs: true, omit: 'data.author.value.data.blocks,data.category.value.data.blocks' },
    })
    .promise();
  if (!content) {
    return {
      notFound: true,
    };
  }

  const { title, category } = content?.data || {};
  const categoryId = category?.id;
  let isLatestArticles = false;

  if (categoryId) {
    const latestArticles = await builder.getAll('blog-article', {
      options: {
        noTargeting: true,
        enrich: true,
        sort: {
          'data.date': -1,
        },
        query: {
          'data.category.id': categoryId,
          'data.slug': { $ne: content?.data?.slug },
        },
      },
      fields:
        'data.title,data.image,data.summary,data.slug,data.date,data.author.value.data.name,data.author.value.data.slug,data.category.value.data.name,data.category.value.data.slug',
      limit: 10,
    });

    // returning this state to hide the whole section in builder if that's the only article in this category.
    isLatestArticles = latestArticles && latestArticles.length > 0;
    content['data'] = {
      ...content.data,
      latestArticles: latestArticles,
    };
  }

  return {
    props: {
      content,
      title,
      isLatestArticles,
    },
  };
}
